<template>
  <div
    :class="b()"
  >
    <el-tooltip
      v-if="isVisible"
      placement="top-start"
      effect="light"
      :value="true"
      :manual="true"
      :shared="false"
      :popper-class="b('light-tip')"
    >
      <div slot="content">
        <div :class="b('blur')"></div>
        <div :class="b('des')">
          {{ $t('guide.new.moreView') }}
        </div>
        <div :class="b('close')">
          <el-button
            round
            type="primary"
            size="small"
            @click="closeMask"
          >
            {{ $t('button.I_know') }}
          </el-button>
        </div>
      </div>
      <div :class="b('linghts')">
        <div :class="b('bulb')">
          <em
            :class="[
              'zkicon',
              'iconliangdiangongneng',
              b('iconliangdiangongneng')
            ]"
          ></em>
        </div>
      </div>
    </el-tooltip>
    <el-tooltip
      placement="top-start"
      :content="$t('guide.task.moreView')"
    >
      <div :class="b('outer')">
        <el-progress
          type="circle"
          :percentage="percentage"
          :show-text="false"
          :width="48"
          :stroke-width="4"
          color="#3c3ec0"
          track-color="#ffffff"
          :class="b('progress')"
          stroke-linecap="square"
        ></el-progress>
        <div
          v-if="!isVisible"
          :class="[b('bulb'), b('tool')]"
          @click="openMenu"
        >
          <!-- <el-progress
            type="circle"
            :percentage="percentage"
            :show-text="false"
            :width="38"
            :stroke-width="2"
            color="rgba(173, 166, 255, 1)"
            track-color="#ffffff"
            :class="b('progress')"
          ></el-progress> -->
          <div
            v-if="finishNum < allNum"
            :class="b('badge')"
          ></div>
          <em
            :class="[
              'zkicon',
              'iconliangdiangongneng',
              b('iconliangdiangongneng')
            ]"
          ></em>
        </div>
      </div>
    </el-tooltip>
    <LightMenu
      v-show="showMenu"
      v-loading="menuLoading"
      v-clickoutside="handleCloseMenu"
      :show="showMenu"
      :lights-data="lightsData"
      @closed="openMenu"
    ></LightMenu>
  </div>
</template>
<script>
import theme from '@zk/theme/lib/variables.scss';
import driverMixin from './CloseModuleDriver';
import LightMenu from './menu.vue';
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: 'HighlightsMenu',
  bemNS: theme.bemNS,
  components: { LightMenu },
  mixins: [driverMixin],
  props:{
    lightsData:{
      type:Object,
      default:()=>({})
    }
  },
  data() {
    return {
      isVisible: false,
      showMenu: true,
      menuLoading:false
    };
  },
  computed:{
    ...mapGetters('user', ['showAsideCollapse']),
    originGuideData(){
      return this.guideData.find((item) => item.step === 10);
    },
    finishNum(){
      return this.lightsData.userQuestList?.filter(item => item.questStatus).length;
    },
    allNum(){
      return (this.lightsData.userQuestList || []).length;
    },
    percentage(){
      return (this.finishNum / this.allNum) * 100;
      // return (userQuestList.filter(item => item.questStatus).length / userQuestList.length) * 100;
    }
  },
  watch: {
    isVisible: {
      immediate: true,
      handler() {
        if (this.isVisible) {
          this.showMask();
          return;
        }
        this.hideMask();
      }
    }
  },
  async mounted() {
    const { closeMask } = this.$route.query;
    if (closeMask && this.showMenu) {
      this.openMenu();
    }
  },
  beforeDestroy() {
    this.hideMask();
  },
  methods: {
    ...mapMutations('guide', ['SET_LIGHT_BULB_SHOWING']),
    hideMask() {
      if (this.mask) {
        this.mask.remove();
        this.mask = null;
      }
    },
    showMask() {
      this.hideMask();
      this.mask = document.createElement('div');
      this.mask.classList.add(this.b('mask'));
      document.body.appendChild(this.mask);
    },
    async closeMask() {
      this.isVisible = false;
      this.menuLoading = false;
    },
    async closeGuide() {
      this.eventBus.$emit('showBulb-highlights', false);
      setTimeout(() => {
        if (this.isOverseasVersion && this.showAsideCollapse){
          return;
        }
        this.openCloseDriver();
      }, 10);
      if (!this.originGuideData){
        return;
      }
      this.updateDetail(false);
    },
    async openMenu() {
      this.showMenu = !this.showMenu;
    },
    handleCloseMenu() {
      // setTimeout(() => {
      //   this.showMenu = false;
      // }, 10);
    },
    updateDetail(){

    }
  }
};
</script>

<style lang="scss" scoped>
@include b(highlights-menu) {
  @include e(blur) {
    width: 71px;
    height: 61px;

    filter: blur(10px);
    position: absolute;
    top: 0;
    left: 0;
  }
  @include e(des) {
    font-weight: bold;
    margin-bottom: 24px;
    font-size: var(--size-font-7)
  }
  @include e(close) {
    text-align: right;
    ::v-deep .el-button {
      font-size: 12px;
      min-width: 68px;
      height: 32px;
      // padding: 8px 10px;
      min-width: 68px;
      .el-button--content{
        min-width: 32px;
      }
    }
  }
  @keyframes scaleBoxShadow {
    0% {
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
    25% {
      box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
    }
    50% {
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
    75% {
      box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
    }
    100% {
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
  }
  @include e(linghts) {
    position: relative;
    left: 0;
    top: 0;
    z-index: 996;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: white;
    // box-shadow: 0px 2px 10px 2px rgba(41, 83, 174, 0.16);
    border: 2px solid var(--primary-color);
    animation: 3s infinite linear scaleBoxShadow;
  }
  @include e(progress){
    position: absolute;
  }
  @include e(badge){
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(235, 69, 66, 1);
    position: absolute;
    right: 8px;
    top: 8px;
    z-index: 9999;
  }
  @include e(bulb) {
    // position: fixed;
    top: -2px;
    left: -2px;
    position: relative;
    z-index: 997;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--primary-color);
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 8px 12px rgba(96, 97, 132, 0.18);
    border: 2px solid #fff;
    @include e(iconliangdiangongneng) {
      // font-size: 18px;
      font-size: 16px;
      color: #fff;
      z-index: 998;
      cursor: pointer;
    }
  }
  @include e(outer){
    // border: 4px solid #f00;
    width: 48px;
    height: 48px;
    border-radius: 50%;
  }
  @include e(tool) {
    top: 4px;
    left: 4px;
    cursor: pointer;
    &:hover {
      @include e(box) {
        max-width: 1000px;
      }
    }
  }
}
</style>
<style lang="scss">
@include b(highlights-menu) {
  @include e(mask) {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: black;
    opacity: 0.3;
    z-index: 995;
    left: 0;
    top: 0;
  }
}
.el-tooltip__popper.zk-highlights-menu__light-tip {
  padding: 24px;
  padding-bottom: 16px;
  width: 288px;
  max-width: 288px;
  border-radius: 6px;
  border: none !important;
  box-shadow: 0px 6px 14px 0px rgba(43, 72, 112, 0.16);
  background-image: radial-gradient(
    circle at 0 0,
    rgba(99, 96, 230, 0.15) 0px,
    #fff 100px
  ) !important;
  .el-button--medium {
    font-size: 12px;
  }
  .popper__arrow {
    border-top-color: #fff !important;
  }
}
</style>
